import * as Actions from '../actions/firmwareReleases.actions';

const initialState = [];

const firmwareReleases = (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_FIRMWARE_RELEASES: {
      return action.payload;
    }
    case Actions.ADD_FIRMWARE_RELEASES: {
      return [...state, action.payload];
    }
    case Actions.UPDATE_FIRMWARE_RELEASES:
    case Actions.GET_FIRMWARE_RELEASE: {
      const index = state.findIndex(
        (firmwareRelease) => firmwareRelease.id === action.payload.id
      );
      const newState = state;
      newState[index > -1 ? index : state.length] = action.payload;
      return [...newState];
    }

    default:
      return state;
  }
};

export default firmwareReleases;
